import React from 'react'
import PropTypes from 'prop-types'
import styles from './style/property_style.module.scss'
import Typography from '../../foundations/typography/Typography'
import PointProgressBar from '../../basics/point-progress-bar/PointProgressBar'

const Property = ({ children, className = '', ...props }) => {
    return (
        <div className={`${styles.property} ${className}`} >
            <Typography typeface="body-s-regular" {...props} >
                {children}
            </Typography>
            <PointProgressBar level={props.level} />
        </div>
    )
};

Property.propTypes = {
    level: PropTypes.number.isRequired,
}

export default Property;